import { createFileRoute } from '@tanstack/react-router';
import { ClientsListPage } from '../features/records/ClientsListPage';

export const Route = createFileRoute('/clients/')({
  component: ClientsListPage,
});
